/**
 * First-party analytics helper.
 * Fire-and-forget POST to /api/events — never blocks the UI, never throws.
 * Call setAnon(true) for under-13 (parent-role) sessions to omit the JWT.
 */
import { supabase } from "./supabase";

const SESSION_ID = (() => {
  const k = "mm_sid";
  const v = sessionStorage.getItem(k);
  if (v) return v;
  const id = crypto.randomUUID();
  sessionStorage.setItem(k, id);
  return id;
})();

const API = import.meta.env.VITE_API_URL as string;
let _anon = false;

/** Call once when auth resolves; prevents JWT attribution for under-13 sessions. */
export function setAnon(v: boolean) { _anon = v; }

export function track(event: string, props?: Record<string, unknown>): void {
  const mode = localStorage.getItem("moneyschool_path_v1") ?? undefined;

  const post = (token?: string) => {
    const headers: Record<string, string> = { "Content-Type": "application/json" };
    if (token) headers["Authorization"] = `Bearer ${token}`;
    fetch(`${API}/api/events`, {
      method: "POST",
      headers,
      body: JSON.stringify({ event, props: props ?? {}, session_id: SESSION_ID, mode }),
    }).catch(() => {});
  };

  try {
    if (supabase && !_anon) {
      supabase.auth.getSession()
        .then(({ data }) => post(data.session?.access_token))
        .catch(() => post());
    } else {
      post();
    }
  } catch {
    // never propagate
  }
}
